import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Index from '@/views/pages/index/index.vue'
import Preview from '@/views/pages/preview/preview.vue'
import Editbase from '@/views/pages/editbase/editbase.vue'
import ProductList from '@/views/pages/product/list.vue'
import Product from '@/views/pages/product/product.vue'
import Cart from '@/views/pages/cart/cart.vue'
import Category from '@/views/pages/category/category.vue'
import OnlineCategory from '@/views/onlinePages/category/category.vue'
import LiveList from '@/views/onlinePages/live/list.vue'
import Live from '@/views/onlinePages/live/live.vue'
import PreLive from '@/views/onlinePages/live/preLive.vue'
import BindPhone from '@/views/pages/public/bindPhone.vue'
import CreateOrder from '@/views/pages/order/createOrder.vue'
import Address from '@/views/pages/address/address.vue'
import AddressManage from '@/views/pages/address/addressManage.vue'
import Pay from '@/views/pages/money/pay.vue'
import Userinfo from '@/views/pages/userinfo/userinfo.vue'
import PaySuccess from '@/views/pages/money/paySuccess.vue'
import PointLog from '@/views/pages/pointLog/pointLog.vue'
import BalanceLog from '@/views/pages/balanceLog/balanceLog.vue'
import ShopOrder from '@/views/pages/order/order.vue'
import OnlineOrder from '@/views/onlinePages/order/order.vue'
import virtualOrder from '@/views/onlinePages/order/virtualOrder.vue'
import OrderDetail from '@/views/pages/order/orderDetail.vue'
import OnlineCourse from '@/views/onlinePages/course/course.vue'
import PreCourse from '@/views/onlinePages/course/preCourse.vue'
import Collectlist from '@/views/pages/collect/list.vue'
import MyLive from '@/views/onlinePages/myLive/myLive.vue'
import Login from '@/views/pages/public/login.vue'
import Search from '@/views/pages/search/search.vue'
import OnlineSource from '@/views/onlinePages/source/source.vue'
import CouponList from '@/views/pages/couponList/couponList.vue'
import Test from '@/views/pages/test/test.vue'
import CardList from '@/views/pages/card/list.vue'
import CardLog from '@/views/pages/card/cardLog.vue'
import Appraise from '@/views/pages/appraise/index.vue'
import Logistics from '@/views/pages/order/commponents/logistics.vue'
import balanceRecord from '@/views/pages/balanceLog/balanceRecord.vue'
import SetPassWord from '@/views/pages/user/SetPassword.vue'
import forgetPwd from '@/views/pages/user/forgetPwd.vue'
import newOldPwd from '@/views/pages/user/newOldPwd.vue'
import MyClient from '@/views/pages/user/MyClient.vue'
import verification from '@/views/pages/order/verification.vue'
import http from '../utils/http'

const defaultShareLogo = require('@/static/img/logo.png')

const getStorageText = (key: string) => {
  const value = localStorage.getItem(key)
  return value && value !== 'undefined' && value !== 'null' ? value : ''
}

const getDefaultShareLogo = () => {
  const logo = defaultShareLogo.default || defaultShareLogo
  if (/^https?:\/\//i.test(logo)) {
    return logo
  }
  return location.origin + (logo.indexOf('/') === 0 ? '' : '/') + logo
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '首页',
      keepAlive: true,
      shareType: 'default',
    },
    
  },
  {
    path: '/pages/preview/preview',
    name: 'Preview',
    component: Preview,
    meta: {
      title: '预览'
    }
  },
  {
    path: '/pages/editbase/editbase',
    name: 'Editbase',
    component: Editbase,
    meta: {
      title: '编辑'
    }
  },
  {
    path: '/pages/product/list',
    name: 'ProductList',
    component: ProductList,
    meta: {
      title: '商品列表',
      shareType: 'default',
    }
  },
  {
    path: '/pages/product/product',
    name: 'Product',
    component: Product,
    meta: {
      title: '商品详情',
      shareType: 'custom'
    }
  },
  {
    path: '/pages/cart/cart',
    name: 'Cart',
    component: Cart,
    meta: {
      title: '购物车'
    }
  },
  {
    path: '/pages/category/category',
    name: 'Category',
    component: Category,
    meta: {
      title: '商品分类',
      shareType: 'default',
    }
  },
  {
    path: '/onlinePages/category/category',
    name: 'OnlineCategory',
    component: OnlineCategory,
    meta: {
      title: '知识分类',
      shareType: 'default',
    }
  },
  {
    path: '/onlinePages/live/list',
    name: 'LiveList',
    component: LiveList,
    meta: {
      title: '直播列表',
      shareType: 'default',
    }
  },
  {
    path: '/onlinePages/live/live',
    name: 'Live',
    component: Live,
    meta: {
      title: '直播详情',
      shareType: 'custom'
    }
  },
  {
    path: '/onlinePages/live/preLive',
    name: 'PreLive',
    component: PreLive,
    meta: {
      title: '直播'
    }
  },
  {
    path: '/pages/public/bindPhone',
    name: 'BindPhone',
    component: BindPhone,
    meta: {
      title: '绑定手机'
    }
  },
  {
    path: '/pages/order/createOrder',
    name: 'CreateOrder',
    component: CreateOrder,
    meta: {
      title: '创建订单'
    }
  },
  {
    path: '/pages/address/address',
    name: 'Address',
    component: Address,
    meta: {
      title: '地址列表'
    }
  },
  {
    path: '/pages/address/addressManage',
    name: 'AddressManage',
    component: AddressManage,
    meta: {
      title: '地址编辑'
    }
  },
  {
    path: '/pages/money/pay',
    name: 'Pay',
    component: Pay,
    meta: {
      title: '支付'
    }
  },
  {
    path: '/pages/money/paySuccess',
    name: 'PaySuccess',
    component: PaySuccess,
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/pages/userinfo/userinfo',
    name: 'Userinfo',
    component: Userinfo,
    meta: {
      title: '用户信息'
    }
  },
  {
    path: '/pages/pointLog/pointLog',
    name: 'PointLog',
    component: PointLog,
    meta: {
      title: '积分记录'
    }
  },
  {
    path: '/pages/balanceLog/balanceLog',
    name: 'BalanceLog',
    component: BalanceLog,
    meta: {
      title: '余额充值'
    }
  },
  {
    path: '/pages/order/order',
    name: 'ShopOrder',
    component: ShopOrder,
    meta: {
      title: '商城订单'
    }
  },
  {
    path: '/pages/order/orderDetail',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      title: '订单详情'
    }
  },
  {
    path: '/onlinePages/order/order',
    name: 'OnlineOrder',
    component: OnlineOrder,
    meta: {
      title: '学习订单'
    }
  },
  {
    path: '/onlinePages/order/virtualOrder',
    name: 'virtualOrder',
    component: virtualOrder,
    meta: {
      title: '线上订单'
    }
  },
  {
    path: '/pages/order/verification',
    name: 'verification',
    component: verification,
    meta: {
      title: '核销'
    }
  },
  
  {
    path: '/onlinePages/course/course',
    name: 'OnlineCourse',
    component: OnlineCourse,
    meta: {
      title: '课程详情',
      shareType: 'custom'
    }
  },
  {
    path: '/onlinePages/course/preCourse',
    name: 'PreCourse',
    component: PreCourse,
    meta: {
      title: '购买课程'
    }
  },
  {
    path: '/pages/collect/list',
    name: 'Collectlist',
    component: Collectlist,
    meta: {
      title: '收藏列表'
    }
  },
  {
    path: '/onlinePages/myLive/myLive',
    name: 'MyLive',
    component: MyLive,
    meta: {
      title: '我的直播'
    }
  },
  {
    path: '/pages/public/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录-注册'
    }
  },
  {
    path: '/pages/search/search',
    name: 'Search',
    component: Search,
    meta: {
      title: '搜索',
      shareType: 'default',
    }
  },
  {
    path: '/onlinePages/source/source',
    name: 'OnlineSource',
    component: OnlineSource,
    meta: {
      title: '资源列表',
      shareType: 'default',
    }
  },
  {
    path: '/pages/test/test',
    name: 'Test',
    component: Test,
    meta: {
      title: '测试',
      shareType: 'default',
    }
  },
  {
    path: '/pages/couponList/couponList',
    name: 'CouponList',
    component: CouponList,
    meta: {
      title: '优惠券',
      shareType: 'default',
    }
  },
  {
    path: '/pages/card/list',
    name: 'CardList',
    component: CardList,
    meta: {
      title: '购物卡',
    }
  },
  {
    path: '/pages/card/cardLog',
    name: 'CardLog',
    component: CardLog,
    meta: {
      title: '购物卡',
    }
  },
  {
    path: '/pages/appraise/index',
    name: 'Appraise',
    component: Appraise,
    meta: {
      title: '评价',
    }
  },
  {
    path: '/pages/order/logistics',
    name: 'Logistics',
    component: Logistics,
    meta: {
      title: '物流信息',
    }
  },
  {
    path: '/pages/balanceLog/balanceRecord',
    name: 'balanceRecord',
    component: balanceRecord,
    meta: {
      title: '余额记录',
    }
  },
  {
    path: '/pages/user/SetPassWord',
    name: 'SetPassWord',
    component: SetPassWord,
    meta: {
      title: '修改交易密码',
    }
  },
  {
    path: '/pages/user/forgetPwd',
    name: 'forgetPwd',
    component: forgetPwd,
    meta: {
      title: '忘记密码',
    }
  },
  {
    path: '/pages/user/newOldPwd',
    name: 'newOldPwd',
    component: newOldPwd,
    meta: {
      title: '设置密码',
    }
  },
  {
    path: '/pages/user/MyClient',
    name: 'MyClient',
    component: MyClient,
    meta: {
      title: '我的客户',
    }
  },
  {
    path: '/pages/user/MyCommission',
    name: 'MyCommission',
    component: () => import('@/views/pages/user/commission.vue'),
    meta: {
      title: '我的佣金',
    }
  },
  {
    path: '/pages/user/bankCard',
    name: 'bankCard',
    component: () => import('@/views/pages/user/bankCard.vue'),
    meta: {
      title: '我的银行卡',
    }
  },
  {
    path: '/pages/user/addBankCard',
    name: 'addBankCard',
    component: () => import('@/views/pages/user/addBankCard.vue'),
    meta: {
      title: '添加银行卡',
    }
  },
  {
    path: '/pages/user/CommissionWithdrawal',
    name: 'CommissionWithdrawal',
    component: () => import('@/views/pages/user/CommissionWithdrawal.vue'),
    meta: {
      title: '佣金提现',
    }
  },
  {
    path: '/pages/user/commissionDetail',
    name: 'commissionDetail',
    component: () => import('@/views/pages/user/commissionDetail.vue'),
    meta: {
      title: '佣金明细',
    }
  },
  {
    path: '/pages/WechatAuth',
    name: 'WechatAuth',
    component: () => import('@/components/WechatAuth.vue'),
    meta: {
      title: '授权登录',
    }
  },

]
const router = new VueRouter({
  // mode: 'history',
  // base: '/mobile/',
  routes
})

router.beforeEach((to, from, next) => {
  //@ts-ignore
  if (to.meta.title) {
    //@ts-ignore
    document.title = to.meta.title
  }
  next()
})
const update = function (to: any) {
  let query = to.query
  if (to.meta.shareType == 'default') {
    let link = location.origin + to.path
    let userId = localStorage.getItem('userId')
    if (userId) {
      query.userId = userId
    }
    for (let key in query) {
      if (link.indexOf('?') == -1) {
        link += '?'
      } else {
        link += '&'
      }
      link += (key + '=' + query[key])
    }
    let desc = getStorageText('desc')
    let shareTitle = getStorageText('shareTitle') ||
      getStorageText('shopTitle') ||
      document.title ||
      '首页'
    let share = {
      title: shareTitle, // 后台配置的分享标题
      desc: desc || '', // 分享描述
      link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: getDefaultShareLogo(), // 首页使用固定校徽分享图
    }
    ///朋友和QQ
    window.wx.updateAppMessageShareData({
      ...share
    })
    ///朋友圈和空间
    window.wx.updateTimelineShareData({
      ...share
    })
    ///微博
    window.wx.onMenuShareWeibo({
      ...share
    });
  } else if (to.meta.shareType == 'custom') {
  } else if (!to.meta.shareType) {
    window.wx.hideOptionMenu()
  }
}
router.afterEach((to, from) => {
  const a = function (to: any) {
    let token = localStorage.getItem('token')
    if (token) {
      http.getJsSdkConfig().then(res => {
        if (to.meta.shareType == 'default') {
          http.request(http.pathMap.orgInfo).then(orgRes => {
            localStorage.setItem('shareTitle', orgRes.data.shareTitle || '')
            localStorage.setItem('desc', orgRes.data.shareDescription || '')
            update(to)
          }).catch(() => update(to))
        } else {
          update(to)
        }
      })
    } else {
      setTimeout(() => {
        a(to)
      }, 600)
    }
  }
  a(to)
})

export default router
